"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var WfActionErrorDialog = /** @class */ (function () {
    function WfActionErrorDialog(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = '';
    }
    WfActionErrorDialog.prototype.onOkClick = function () {
        this.dialogRef.close();
    };
    WfActionErrorDialog.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-wf-action-error-dialog',
                    template: "\n\t\t<h1 mat-dialog-title>{{data | sisTranslateMessage | async}}</h1>\n\t\t<div mat-dialog-content>\n\t\t\t<p>{{title}}</p>\n\t\t</div>\n\t\t<div mat-dialog-actions>\n\t\t\t<button mat-raised-button color=\"primary\" (click)=\"onOkClick()\">{{'portfolio.ok.message' | sisTranslateMessage | async}}</button>\n\t\t</div>\n\t"
                },] },
    ];
    /** @nocollapse */
    WfActionErrorDialog.ctorParameters = function () { return [
        { type: material_1.MatDialogRef, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
    ]; };
    return WfActionErrorDialog;
}());
exports.WfActionErrorDialog = WfActionErrorDialog;
//# sourceMappingURL=wf-action-error-dialog.component.js.map